import { useFeatureValue } from '@growthbook/growthbook-react';
import { useMediaQuery } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { SearchBarComponent } from '@/components';
import { Routes } from '@/constants';
import { uiActions, useLazyFetchQuerySuggestionsQuery } from '@/store';

export const SearchBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const isDesktop = useMediaQuery(theme => theme.breakpoints.up('lg'));

  const isQuerySuggestionsEnabled = useFeatureValue(
    'search-query-suggestions',
    false,
  );

  const query = new URLSearchParams(location.search);
  const { searchTerm: urlSearchTerm = '' } = Object.fromEntries(
    query.entries(),
  );

  const [fetchQuerySuggestions, { data: querySuggestions = [] }] =
    useLazyFetchQuerySuggestionsQuery();

  const onSearch = (value: string) => {
    if (value) {
      navigate({
        pathname: Routes.SEARCH,
        search: `?searchTerm=${encodeURIComponent(value)}`,
      });
    } else {
      navigate({
        pathname: Routes.DISCOVER,
      });
    }
  };

  const onUpdateQuerySuggestions = (value: string) => {
    if (!isQuerySuggestionsEnabled) return;
    fetchQuerySuggestions({ searchTerm: value });
  };

  const onFocus = () => {
    if (!isQuerySuggestionsEnabled) return;
    fetchQuerySuggestions({ searchTerm: urlSearchTerm });
  };

  const onIconClick = () => {
    dispatch(uiActions.closeSidebarDrawer());
  };

  return (
    <SearchBarComponent
      onSearch={onSearch}
      onUpdateQuerySuggestions={onUpdateQuerySuggestions}
      onIconClick={onIconClick}
      onFocus={onFocus}
      querySuggestions={querySuggestions}
      initialValue={urlSearchTerm}
      expandable={!isDesktop}
      darkMode
    />
  );
};
